import videojs from 'video.js';

const DEFAULT_MARKER_ICON = `<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg">
    <path d = "M5.82199 6.81355C5.42431 7.38756 4.57569 7.38756 4.17801 6.81355L0.891225 2.0695C0.431746 1.40629 0.906401 0.500001 1.71322 0.500001L8.28678 0.5C9.0936 0.5 9.56825 1.40629 9.10877 2.06949L5.82199 6.81355Z"/>
</svg >`

export default class TimelineMarkerIcon extends videojs.getComponent('Component') {
    /**
     * 
     * @param {videojs.Player} player
     */
    constructor(player, options) {
        super(player, options);

        player.ready(() => {
            const { shape } = options;
            const timelineMarkerIcon = this.generateMarkerIcon(shape);
            this.el().appendChild(timelineMarkerIcon);
        });
    }

    generateMarkerIcon(shape) {
        const container = document.createElement('div');
        videojs.dom.addClass(container, 'mediasite-player__timeline-marker-icon');
        if (shape == null || shape === "") {
            container.innerHTMl = DEFAULT_MARKER_ICON;
        } else {
            container.innerHTML = shape;
        }
        return container;
    }

    createEl(tag, props = {}, attributes = {}) {
        tag = 'div';
        props = Object.assign({
            className: 'mediasite-player__timeline-marker-icon-wrapper'
        });

        return super.createEl.call(this, tag, props, attributes);
    }
}